import AuthorizedDeviceEnrollmentPage from "components/pages/AuthorizedDeviceEnrollmentPage";

export default function CaptureMabiFaceIDDeviceEnroll(props) {
    return <AuthorizedDeviceEnrollmentPage /> 
}